import { createAction } from '@reduxjs/toolkit';
import { DaoInfo } from './interfaces/data.interface';

export const fetchNFT = createAction<void>('token/fetchNFT');
export const fetchNFTSuccess = createAction<{
  amountByLevel: number[];
  daoInfo: DaoInfo;
}>('token/fetchNFTSuccess');
export const fetchNFTError = createAction<{ error: Error }>('token/fetchNFTError');
